export const DAILY_WEEKLY_HEADERS = [
  {
    label: 'Date',
    key: 'report_date',
    condition: () => true,
  },
  {
    label: 'Team',
    key: 'team_id',
    condition: () => true,
  },
  {
    label: 'Task ID',
    key: 'imsma_id',
    condition: () => true,
  },
  {
    label: 'Task Type',
    key: 'task_type',
  },
  // {
  //   label: 'Period',
  //   key: 'type',
  //   condition: () => true
  // },
  {
    label: (
      <>
        Area (m²)
        <br />
        Cleared area (m²)
      </>
    ),
    key: 'area',
  },
  {
    label: 'EO found',
    key: 'imsma_id',
    style: { textAlign: 'start' },
  },
  {
    label: 'Status',
    condition: () => true,
  },
  {
    label: 'Action',
    condition: () => true,
  },
];

export const NTS_HEADERS = [
  {
    label: 'Date',
    key: 'report_date',
    condition: () => true,
    style: { flex: '120px' },
  },
  {
    label: 'Team',
    key: 'team_id',
    condition: () => false,
    style: { flex: '80px' },
  },
  {
    label: 'Local community',
    key: 'local_community',
    condition: () => false,
    style: { flex: '120px' },
  },
  {
    label: 'Polygon name',
    key: 'hazard_name',
    condition: () => false,
    style: { flex: '90px' },
  },
  {
    label: 'Type(NTS or VBV)',
    key: 'nts_type',
    condition: () => false,
    style: { flex: '80px' },
  },
  {
    label: 'IMSMA ID',
    key: 'imsma_id',
    condition: () => false,
    style: { flex: '200px' },
  },
  {
    label: 'Status',
    key: 'validation_status',
    condition: () => false,
    style: { flex: '120px' },
  },
  {
    label: 'Action',
    condition: () => false,
    style: { flex: '120px' },
  },
];

export const HA_HEADERS = [
  {
    label: 'Date',
    key: 'report_date',
    style: { flex: '90px' },
    condition: () => true,
  },
  {
    label: 'Team',
    key: 'team_id',
    style: { flex: '100px' },
    condition: () => false,
  },
  {
    label: 'Local community',
    key: 'local_community',
    style: { flex: '100px' },
    condition: () => false,
  },
  {
    label: 'Polygon name',
    key: 'hazard_name',
    condition: () => false,
    style: { flex: '90px' },
  },
  {
    label: 'Type(SHA/CHA)',
    style: { flex: '120px' },
    key: 'ha_area_type',
    condition: () => false,
  },
  {
    label: 'Type(MF/BAC)',
    style: { flex: '120px' },
    key: 'ha_mf_bac_type',
    condition: () => false,
  },
  {
    label: 'Square',
    key: 'area',
    condition: () => true,
    style: { flex: '120px' },
  },
  {
    label: 'IMSMA ID',
    key: 'imsma_id',
    condition: () => false,
    style: { flex: '150px' },
  },
  {
    label: 'Status',
    key: 'validation_status',
    condition: () => false,
    style: { flex: '120px' },
  },
  {
    label: 'Action',
    condition: () => false,
    style: { flex: '100px' },
  },
];

export const CLEARANCE_TASK_HEADERS = [
  { label: 'Name', key: 'hazard_name', condition: () => true },
  { label: 'Internal ID', key: 'internal_id', condition: () => true },
  { label: 'Start date', key: 'start_date', condition: () => true },
  { label: 'Donor', key: 'donor', condition: () => true },
  { label: 'EO found', key: 'eo_found' },
  {
    label: (
      <>
        Area (m²)
        <br />
        Cleared area (m²)
      </>
    ),
    key: 'ha_area',
  },
  { label: 'Files', key: 'files_progress' },
  { label: 'Status', key: 'validation_status' },
  { label: 'Action', key: 'actions' },
];

export const DAILY_HEADERS = [
  { label: 'Date', key: 'report_date', condition: () => true },
  { label: 'Team', key: 'team_id', condition: () => true },
  { label: 'Task Id', key: 'imsma_id', condition: () => true },
  { label: 'Task Type', key: 'task_type' },
  {
    label: (
      <>
        Area (m²)
        <br />
        Cleared area (m²)
      </>
    ),
    key: 'area_cleared_area',
  },
  { label: 'EO found', key: 'eo_found' },
  { label: 'Status', key: 'validation_status' },
  { label: 'Action', key: 'actions' },
];

export const WEEKLY_HEADERS = [
  { label: 'Date', key: 'created_at', condition: () => true },
  { label: 'Internal ID', key: 'internal_id', condition: () => true },
  { label: 'Period', key: 'earlier_report_date', condition: () => true },
  { label: 'Task Type', key: 'type' },
  {
    label: (
      <>
        Area (m²)
        <br />
        Cleared area (m²)
      </>
    ),
    key: 'area_cleared_area',
  },
  { label: 'EO found', key: 'eo_found' },
  { label: 'Status', key: 'validation_status' },
  { label: 'Action', key: 'actions' },
];

export const EORE_HEADERS = [
  { label: 'Date', key: 'report_date', condition: () => true },
  { label: 'Team', key: 'team_name', condition: () => false },
  { label: 'Local community', key: 'local_community_name', condition: () => false },
  { label: 'Settlement', key: 'settlement_name', condition: () => false },
  { label: 'Type of place', key: 'place_type_imsma', condition: () => false },
  { label: 'Type of session', key: 'eore_type_imsma', condition: () => false },
  { label: 'Beneficiaries total', key: 'total_beneficiaries_count', condition: () => true },
  { label: 'Status', key: 'validation_status', condition: () => false },
  { label: 'Action', key: 'actions', condition: () => false, style: { width: '120px' } },
];
